module.exports = __webpack_public_path__ + "img/medical-equipment.ddeeba79.png";